// src/__generated__/procedureMap.ts
var procedureMap = {
  "admission.getAll": "",
  "admission.getById": "",
  "admission.resume": "",
  "admission.pause": "",
  "admission.invalidate": "",
  "admission.discharge": "",
  "admission.update": "",
  "admission.create": "",
  "organization.create": "",
  "organization.getAll": "",
  "organization.getById": "",
  "organization.updateContact": "",
  "organization.updateGeneral": "",
  "organization.getAllInsurance": "",
  "group.getAll": "",
  "group.getById": "",
  "group.create": "",
  "group.update": "",
  "group.updateMembers": "",
  "device.getById": "",
  "device.getAll": "",
  "device.create": "",
  "device.update": "",
  "device.usage.create": "",
  "device.usage.cancel": "",
  "device.usage.terminate": "",
  "device.usage.getAll": "",
  "device.createBulk": "",
  "device.calibratePatch": "",
  "device.getDeviceMetrics": "",
  "device.getMDMStatus": "",
  "device.getBandStatus": "",
  "device.reboot": "",
  "media.create": "",
  "media.getAll": "",
  "media.getById": "",
  "media.createUploadURL": "",
  "media.getDownloadURL": "",
  "media.update": "",
  "chargeItemDefinition.getAll": "",
  "chargeItemDefinition.getById": "",
  "chargeItemDefinition.create": "",
  "chargeItemDefinition.update": "",
  "claim.getAll": "",
  "claim.getById": "",
  "claim.update": "",
  "claim.submit": "",
  "claimResponse.getAll": "",
  "claimResponse.getById": "",
  "claimResponse.reverse": "",
  "communication.getById": "",
  "communication.conversation.sendMessage": "",
  "communication.conversation.sendTemplateMessage": "",
  "communication.conversation.getAllAlerts": "",
  "communication.conversation.getAll": "",
  "claimTemplate.getAll": "",
  "claimTemplate.getByType": "",
  "claimTemplate.create": "",
  "claimTemplate.update": "",
  "practitioner.getAll": "",
  "practitioner.getById": "",
  "practitioner.getTasks": "",
  "practitioner.create": "",
  "practitioner.getByOrganizations": "",
  "practitioner.saveHospitalSettings": "",
  "practitioner.getProfile": "",
  "practitioner.updateUserPreferences": "",
  "practitioner.updateStatus": "",
  "practitioner.updateContact": "",
  "practitioner.updateGeneral": "",
  "practitioner.updateQualification": "",
  "practitioner.settings": "",
  "practitioner.external": "",
  "relatedPerson.create": "",
  "relatedPerson.update": "",
  "relatedPerson.updateContact": "",
  "relatedPerson.updateGeneral": "",
  "relatedPerson.getAll": "",
  "relatedPerson.getById": "",
  "patient.getAll": "",
  "patient.getById": "",
  "patient.getNotes": "",
  "patient.getTasks": "",
  "patient.createObservation": "",
  "patient.createPathologyRequest": "",
  "patient.noteUpdate": "",
  "patient.createNote": "",
  "patient.generalPractitioner": "",
  "patient.getPrivatePatient": "",
  "patient.createPrivatePatient": "",
  "patient.createPathologyOrder": "",
  "patient.getAllergy": "",
  "patient.updateAllergy": "",
  "patient.createAllergy": "",
  "patient.getPathologyTests": "",
  "patient.createMedicalAidPatient": "",
  "patient.getMedicalAidPatient": "",
  "patient.updatePrivatePatient": "",
  "patient.updateMedicalAid": "",
  "patient.updatePatientContact": "",
  "patient.updatePatientGeneral": "",
  "patient.getObservation": "",
  "patient.startCall": "",
  "patient.endCall": "",
  "patient.callBack": "",
  "patient.search": "",
  "place.getPlace": "v2",
  "place.getAddress": "v2",
  "user.addPushToken": "v2",
  "user.removePushToken": "v2",
  "medicationStatement.getAll": "v2",
  "medicationStatement.create": "v2",
  "medication.search": "v2",
  "consumable.getAll": "v2",
  "consumable.create": "v2",
  "consumable.searchConsumables": "v2",
  "consumable.update": "v2",
  "coverage.create": "v2",
  "coverage.familyCheck": "v2",
  "coverage.getByPatient": "v2",
  "relay.getStatusById": "v2",
  "task.update": "v2",
  "task.create": "v2",
  "template.getAll": "v2",
  "specialty.getAll": "v2",
  "administrator.getAll": "v2",
  "scheme.getAll": "v2",
  "careTeam.create": "v2",
  "careTeam.getAll": "v2",
  "careTeam.getById": "v2",
  "careTeam.update": "v2",
  "videoConsult.sendInvite": "v2",
  "videoConsult.createMeetingRoom": "v2",
  "vitals.getByName": "v2",
  "vitals.getByPatient": "v2",
  "vitals.getByTracking": "v2",
  "condition.create": "v2",
  "condition.getById": "v2",
  "condition.getAll": "v2",
  "condition.update": "v2",
  "carePlan.getAll": "v2",
  "carePlan.getById": "v2",
  "carePlan.update": "v2",
  "carePlan.getByPatient": "v2",
  "carePlan.discharge": "v2",
  "carePlan.resume": "v2",
  "carePlan.pause": "v2",
  "carePlan.escalation": "v2",
  "carePlan.create": "v2",
  "questionnaire.getAll": "v2",
  "questionnaire.getById": "v2",
  "questionnaireResponse.getAll": "v2",
  "questionnaireResponse.update": "v2",
  "icd10.getAll": "v2",
  "flag.create": "v3",
  "allergy.getAll": "v3",
  "getPathologyReportWithObservations.getPathologyReportWithObservations": "v3",
  "location.create": "v3",
  "location.getAll": "v3",
  "location.getById": "v3",
  "location.update": "v3",
  "pathologyRequest.getAll": "v3",
  "pathologyRequest.searchTests": "v3",
  "pathologyRequest.create": "v3",
  "pathologyReport.getAll": "v3",
  "pathologyReport.getById": "v3",
  "pathologyReport.getPresentedForm": "v3",
  "document.create": "v3",
  "document.getAll": "v3",
  "document.getDownloadURL": "v3",
  "planDefinition.getAll": "v3"
};
export {
  procedureMap
};
//# sourceMappingURL=client.mjs.map